import {Component, OnInit} from "@angular/core";
import {ActivatedRoute}    from "@angular/router";
import {SchemaSettings}    from "./components/schema.models";
import {Schema}            from '../shared/api/bases/proxy/schemas/schema.interface';
import {ContactMoment}     from '../shared/api/bases/proxy/schemas/contactMoments/api.models';
import {Base}              from '../shared/api/bases/api.models';

@Component({
    selector : 'edit-schema',
    template: require('./edit.component.html')
})

export class EditSchemaComponent implements OnInit {
    public base: Base;
    public schema: Schema;
    public moments: ContactMoment[];
    public settings: SchemaSettings = new SchemaSettings();

    constructor(private route: ActivatedRoute) {}

    ngOnInit() {
        this.base     = this.route.snapshot.data['base'] as Base;
        this.schema   = this.route.snapshot.data['schema'] as Schema;
        this.moments  = this.route.snapshot.data['contactMoments'].result as ContactMoment[];
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/schemas/edit.component.ts